import { seededRandom } from '@libs/random';
import { CollapseIcon } from '@ui/components/CollapseIcon';
import { HorizontalScroll } from '@ui/components/HorizontalScroll';
import { Table, TableCell, TableRow } from '@ui/components/Table';

import sharedStyles from './RoundMovement.module.css';
import styles from './RoundMovementSkeleton.module.css';

type Props = {
  rowCount: number;
  isTeam?: boolean;
};

export function RoundMovementSkeleton({ rowCount, isTeam }: Props) {
  const rows = Array.from({ length: rowCount }, (_, i) => i);

  return (
    <HorizontalScroll>
      <Table className={sharedStyles.root}>
        <TableRow header>
          {!isTeam && <TableCell className={sharedStyles.tableHeader}>Стол</TableCell>}
          <TableCell>Игрок</TableCell>
          <TableCell className={sharedStyles.resultsHeader} />
        </TableRow>

        {rows.map((i) => (
          <TableRow key={i} hoverable>
            {!isTeam && <TableCell className={sharedStyles.no}>{i + 1}</TableCell>}
            <TableCell className={sharedStyles.playerName}>
              <div className={sharedStyles.playerNameContainer}>
                <span className={styles.skeleton} style={{ width: 100 + seededRandom(i) * 80 }} />
              </div>
            </TableCell>
            <TableCell>{isTeam && <CollapseIcon className={styles.collapse} />}</TableCell>
          </TableRow>
        ))}
      </Table>
    </HorizontalScroll>
  );
}
